// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  min-width: 32px;
  min-height: 32px;
  padding: 6px 12px;
  color: #111314;
  font-weight: 500;
  font-size: 14px;
  text-decoration: none;
  background-color: white;
  border: 1px solid #d9dbde;
  border-radius: 2px;
  cursor: pointer !important;
}

  .Button:focus {
    outline: none;
  }

  .Button--theme-1 {
    color: white;
    background-color: #41a741;
    border: 0;
  }

  .Button--theme-2 {
    color: white;
    background-color: #2a2d30;
    border: 0;
  }

  .Button--theme-2:focus,
    .Button--theme-2:hover {
      background-color: white;
      color: #000;
      border: solid thin #2a2d30;
    }

  .Button--theme-3 {
    color: white;
    background-color: #276de2;
    border: 0;
  }

  .Button--disabled {
    color: var(--color-gray-4);
    background-color: #f6f6f7;
    box-shadow: none;
    pointer-events: none;
  }

  /* Layout */

  .Button-layout--rtl {
    flex-direction: row-reverse;
  }

  .Button--circle {
    border-radius: 50%;
  }

  .Button--floating {
    box-shadow: -4px 2px 8px rgb(0 0 0 / 8%);
  }

  .Button--floating:active {
      box-shadow: none;
    }

  .Button--floating:active svg {
        height: 11px;
      }

  .Button--transparent {
    background-color: transparent;
  }

  /* Variants */

  /* Outlined */

  .Button-type-outlined {
      background: none;
      border: solid 1px currentcolor;
      box-shadow: none;
    }

  .Button-type-outlined--theme-1 {
        color: var(--color-gray-1);
      }

  .Button-type-outlined--theme-2 {
        color: white;
      }

  .Button-type-outlined--disabled {
        color: var(--color-gray-1);

        /* color: var(--color-gray-5); */

        border-color: var(--color-gray-1);
        pointer-events: none;
      }

  /* Text */

  .Button-type-text {
      background: none;
      box-shadow: none;
      border: 0;
    }

  .Button-type-text--theme-1 {
        color: var(--color-gray-1);
      }

  .Button-type-text--theme-2 {
        color: white;
      }

  .Button-type-text--disabled {
        color: var(--color-gray-4);
        background: none;
        pointer-events: none;
      }

  /* icon spacer */

  .Button > div {
    width: 8px;
    height: 8px;
  }

  /*  SVG icon */

  .Button > svg {
    width: 12px;
    height: 12px;
    fill: currentcolor;
  }
`, "",{"version":3,"sources":["webpack://./app/components/Button/style.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,qBAAqB;EACrB,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,0BAA0B;AA2H5B;;EAzHE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,yBAAyB;IACzB,SAAS;EAQX;;EANE;;MAEE,uBAAuB;MACvB,WAAW;MACX,0BAA0B;IAC5B;;EAGF;IACE,YAAY;IACZ,yBAAyB;IACzB,SAAS;EACX;;EAEA;IACE,0BAA0B;IAC1B,yBAAyB;IACzB,gBAAgB;IAChB,oBAAoB;EACtB;;EAEA,WAAW;;EACX;IACE,2BAA2B;EAC7B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,wCAAwC;EAS1C;;EAPE;MACE,gBAAgB;IAKlB;;EAHE;QACE,YAAY;MACd;;EAIJ;IACE,6BAA6B;EAC/B;;EAEA,aAAa;;EAEX,aAAa;;EACb;MACE,gBAAgB;MAChB,8BAA8B;MAC9B,gBAAgB;IAkBlB;;EAhBE;QACE,0BAA0B;MAC5B;;EAEA;QACE,YAAY;MACd;;EAEA;QACE,0BAA0B;;QAE1B,gCAAgC;;QAEhC,iCAAiC;QACjC,oBAAoB;MACtB;;EAGF,SAAS;;EACT;MACE,gBAAgB;MAChB,gBAAgB;MAChB,SAAS;IAeX;;EAbE;QACE,0BAA0B;MAC5B;;EAEA;QACE,YAAY;MACd;;EAEA;QACE,0BAA0B;QAC1B,gBAAgB;QAChB,oBAAoB;MACtB;;EAIJ,gBAAgB;;EAChB;IACE,UAAU;IACV,WAAW;EACb;;EAEA,cAAc;;EACd;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":[".Button {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: center;\n  min-width: 32px;\n  min-height: 32px;\n  padding: 6px 12px;\n  color: #111314;\n  font-weight: 500;\n  font-size: 14px;\n  text-decoration: none;\n  background-color: white;\n  border: 1px solid #d9dbde;\n  border-radius: 2px;\n  cursor: pointer !important;\n\n  &:focus {\n    outline: none;\n  }\n\n  &--theme-1 {\n    color: white;\n    background-color: #41a741;\n    border: 0;\n  }\n\n  &--theme-2 {\n    color: white;\n    background-color: #2a2d30;\n    border: 0;\n\n    &:focus,\n    &:hover {\n      background-color: white;\n      color: #000;\n      border: solid thin #2a2d30;\n    }\n  }\n\n  &--theme-3 {\n    color: white;\n    background-color: #276de2;\n    border: 0;\n  }\n\n  &--disabled {\n    color: var(--color-gray-4);\n    background-color: #f6f6f7;\n    box-shadow: none;\n    pointer-events: none;\n  }\n\n  /* Layout */\n  &-layout--rtl {\n    flex-direction: row-reverse;\n  }\n\n  &--circle {\n    border-radius: 50%;\n  }\n\n  &--floating {\n    box-shadow: -4px 2px 8px rgb(0 0 0 / 8%);\n\n    &:active {\n      box-shadow: none;\n\n      & svg {\n        height: 11px;\n      }\n    }\n  }\n\n  &--transparent {\n    background-color: transparent;\n  }\n\n  /* Variants */\n  &-type {\n    /* Outlined */\n    &-outlined {\n      background: none;\n      border: solid 1px currentcolor;\n      box-shadow: none;\n\n      &--theme-1 {\n        color: var(--color-gray-1);\n      }\n\n      &--theme-2 {\n        color: white;\n      }\n\n      &--disabled {\n        color: var(--color-gray-1);\n\n        /* color: var(--color-gray-5); */\n\n        border-color: var(--color-gray-1);\n        pointer-events: none;\n      }\n    }\n\n    /* Text */\n    &-text {\n      background: none;\n      box-shadow: none;\n      border: 0;\n\n      &--theme-1 {\n        color: var(--color-gray-1);\n      }\n\n      &--theme-2 {\n        color: white;\n      }\n\n      &--disabled {\n        color: var(--color-gray-4);\n        background: none;\n        pointer-events: none;\n      }\n    }\n  }\n\n  /* icon spacer */\n  & > div {\n    width: 8px;\n    height: 8px;\n  }\n\n  /*  SVG icon */\n  & > svg {\n    width: 12px;\n    height: 12px;\n    fill: currentcolor;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
